import { createContext } from "react"
import moment from "moment-jalaali"

export const store = createContext(null);
export const initialState = {
    startDate: moment().startOf('jYear'),
    endDate: moment().endOf('jYear'),
    customers: true,
    operators: true,
    drivers: true,
    progress: false,
    page: 1,
    reports: null,
    user: null,
    totalCommission: null

}
export const reducer = (state, actions) => {
    const { payload, type } = actions;
    switch (type) {
        case 'PROGRESS':
            return { ...state, progress: payload }
        case 'CHANGE_START_DATE':
            return { ...state, startDate: moment(payload).startOf('jYear') };
        case 'CHANGE_END_DATE':
            return { ...state, endDate: moment(payload).endOf('jYear') };
        case 'CHANGE_CHECKBOXES':
            return { ...state, [payload.name]: payload.checked };
        case 'CHANGE_PAGE':
            return { ...state, page: payload };
        case 'CHANGE_USER':
            return { ...state, user: payload };
        case 'REPORTS':
            return { ...state, reports: payload }
        case 'TOTAL_COMMISSION':
            return { ...state, totalCommission: payload }

        default:
            return { ...state }
    }
}